/* eslint-disable no-shadow */

const state = {
  fieldTypesWithOptions: ['dropdown', 'checkbox', 'radio', 'multipletext', 'opinionrange'],
  fieldTypesWithInputBox: ['text', 'textarea', 'integer', 'emailaddress'],
  inputTypes: {
    text: {
      name: 'Text Box',
      icon: 'input',
      vfg: {
        type: 'customInput',
        inputType: 'text',
      },
    },
    textarea: {
      name: 'Multi-Line Text Box',
      icon: 'subject',
      vfg: {
        type: 'customTextArea',
        rows: 4,
      },
    },
    multipletext: {
      name: 'Text Boxes',
      icon: 'short_text',
      vfg: {
        type: 'multipleInput',
      },
    },
    statictext: {
      name: 'Static Text',
      icon: 'insert_comment',
      vfg: {
        type: 'staticText',
      },
    },
    emailaddress: {
      name: 'Email Address',
      icon: 'email',
      vfg: {
        type: 'customInput',
        inputType: 'text'
      },
    },
    integer: {
      name: 'Number',
      icon: 'filter_1',
      vfg: {
        type: 'customInput',
        inputType: 'number',
      },
    },
    boolean: {
      name: 'Checkbox',
      icon: 'flip',
      vfg: {
        type: 'customCheckbox',
      },
    },
    checkbox: {
      name: 'Checkboxes',
      icon: 'check_box',
      vfg: {
        type: 'customChecklist',
        listBox: true,
      },
    },
    radio: {
      name: 'Radio',
      icon: 'radio_button_checked',
      vfg: {
        type: 'customRadios',
      },
    },
    dropdown: {
      name: 'Drop Down',
      icon: 'menu',
      vfg: {
        type: 'customSelect',
      },
    },
    file: {
      name: 'File Upload',
      icon: 'attach_file',
      vfg: {
        type: 'fileUpload',
      },
    },
    date: {
      name: 'Date',
      icon: 'date_range',
      vfg: {
        type: 'flatpickr',
      },
    },
    time: {
      name: 'Time',
      icon: 'access_time',
      vfg: {
        type: 'flatpickr',
        flatpickrOptions: {
          enableTime: true,
          noCalendar: true,
        },
      },
    },
    datetime: {
      name: 'Date/Time',
      icon: 'av_timer',
      vfg: {
        type: 'flatpickr',
        flatpickrOptions: {
          enableTime: true,
        },
      },
    },
    duration: {
      name: 'Duration',
      icon: 'timelapse',
      vfg: {
        type: 'duration',
      },
    },
    opinionscale: {
      name: 'Opinion (Single)',
      icon: 'linear_scale',
      vfg: {
        type: 'opinionScale',
      },
    },
    opinionrange: {
      name: 'Opinion (Multiple)',
      icon: 'more_horiz',
      vfg: {
        type: 'opinionRange',
      },
    },
    button: {
      name: 'Button',
      icon: 'submit',
      vfg: {
        type: 'button',
      },
    },
    submit: {
      name: 'Submit',
      icon: 'submit',
      vfg: {
        type: 'customSubmit',
        validateBeforeSubmit: false,
      },
    },
    slider: {
      name: 'Slider',
      icon: 'space_bar',
      vfg: {
        type: 'customNoUiSlider',
      },
    },
  },
};

const getters = {
  fieldHasOptions: state => fieldType => state.fieldTypesWithOptions.includes(fieldType),
  fieldHasInputBox: state => fieldType => state.fieldTypesWithInputBox.includes(fieldType),
};

const mutations = {

};

const actions = {

};

export default {
  state,
  getters,
  mutations,
  actions,
};
